const productList = {
	group: '功能介绍',
	list: [
		{
			id: 11,
			name: 'regulation',
			title: '法规标准库',
			goto: { path: '/info', query: { group: '功能介绍', id: 11, type: 'content', title: '法规标准库' } },
			class: '',
			content: '标准法规介绍内容'
		},
		{
			id: 14,
			name: 'AI-行业大模型',
			title: 'AI-行业大模型',
			goto: { path: '/info', query: { group: '功能介绍', id: 14, type: 'content', title: 'AI-行业大模型' } },
			class: '',
			content: 'AI-行业大模型内容'
		},
		// {
		// 	id: 12,
		// 	name: 'data',
		// 	title: '行业数据库',
		// 	goto: { path: '/info', query: { group: '功能介绍', id: 12, type: 'content', title: '行业数据库' } },
		// 	class: '',
		// 	content: '行业数据介绍内容'
		// },
		// {
		// 	id: 13,
		// 	name: 'community',
		// 	title: '社区',
		// 	goto: { path: '/info', query: { group: '功能介绍', id: 13, type: 'content', title: '社区' } },
		// 	class: '',
		// 	content: '社区介绍内容'
		// },
		{
			id: 26,
			name: 'bookshelf',
			title: '个人书架',
			goto: { path: '/info', query: { group: '功能介绍', id: 26, type: 'content', title: '个人书架' } },
			class: '',
			content: '个人书架内容'
		},
		{
			id: 16,
			name: 'bookshelf',
			title: '企业资料馆',
			goto: { path: '/info', query: { group: '功能介绍', id: 16, type: 'content', title: '企业资料馆' } },
			class: '',
			content: '书架内容'
		},

		{
		    id: 15,
		    name: 'bookstore',
		    title: '正版图书购买',
		    goto: { path: '/info', query: {group: '功能介绍', id:15,type: 'content',title: '正版图书购买'} },
		    class: '',
		    content: '网上书城内容'
		}
	]
};

export default productList;
